import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { getCurrentUser } from 'aws-amplify/auth';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import { amplifyConfig } from './amplify-config';
import ServerList from './components/ServerList';
import { ThemeProvider } from './design-system/ThemeProvider';
import { Sidebar } from './components/Navigation/Sidebar';

Amplify.configure(amplifyConfig);

function App() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      console.log('No user signed in');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="App">
        <header className="App-header">
          <p>Loading...</p>
        </header>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <div className="App">
        <Authenticator>
          {({ signOut, user }) => (
            <div style={{ 
              minHeight: '100vh',
              display: 'flex'
            }}>
              {/* Professional Navigation Sidebar */}
              <Sidebar user={user} onSignOut={signOut} />

              {/* Main Content Area */}
              <main style={{
                flex: 1,
                marginLeft: '280px'
              }}>
                <ServerList user={user} />
              </main>
            </div>
          )}
        </Authenticator>
      </div>
    </ThemeProvider>
  );
}

export default App;
